export var ReportDataType;
(function (ReportDataType) {
    ReportDataType["NONE"] = "NONE";
    ReportDataType["FILTER_LOOKUP"] = "FILTER_LOOKUP";
    ReportDataType["DATE_RANGE"] = "DATE_RANGE";
    ReportDataType["TIME_INTERVAL"] = "TIME_INTERVAL";
    ReportDataType["TIMEZONE"] = "TIMEZONE";
})(ReportDataType || (ReportDataType = {}));
